// extracted by mini-css-extract-plugin
module.exports = {"Chart":"chart_Chart__1_ABd"};